import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimesCircle, FaHome, FaArrowLeft, FaCreditCard } from 'react-icons/fa';
import './PaymentCancel.css';

const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleRetryPayment = () => {
    navigate('/register');
  };

  return (
    <div className="payment-cancel-container">
      <div className="cancel-card">
        <div className="cancel-icon">
          <FaTimesCircle />
        </div>
        
        <h1>Payment Cancelled</h1>
        <p className="cancel-message">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        
        <div className="cancel-info">
          <h3>What happened?</h3>
          <ul>
            <li>You chose to cancel the payment process</li>
            <li>The payment window was closed</li>
            <li>You navigated away from the payment page</li>
          </ul>
        </div>
        
        <div className="help-text">
          <p>
            Don't worry! Your registration information is still available. 
            You can try again anytime.
          </p>
        </div>
        
        <div className="action-buttons">
          <button onClick={handleRetryPayment} className="btn btn-primary">
            <FaCreditCard className="btn-icon" />
            Try Payment Again
          </button>
          <button onClick={handleGoHome} className="btn btn-secondary">
            <FaHome className="btn-icon" />
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;

